<!--
  Main welcome screen
-->
<template>
  <section>
    <div class="container has-text-centered">
      <div class="hero-body">
        <div class="columns is-vcentered welcome-box has-background-white">
          <div class="column is-12">
            <span class="is-size-1 has-text-primary has-text-weight-bold">
              {{ $t('omw-primary-company') }}
            </span>
            <p class="has-text-primary is-size-3">
              {{ $t('omw-welcome-title') }}
            </p>
            <div>
              <div
                class="buttons"
                style="justify-content: center; margin-top: 1em"
              >
                <b-button type="is-primary" @click="onSignup">
                  {{ $t('user-admin-signup') }}
                </b-button>

                <b-button type="is-primary" @click="onLogin">
                  {{ $t('user-admin-login-button-label') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'WelcomeScreen',
  computed: {
    samlActive() {
      return this.$configData?.auth?.saml?.active;
    },
    oidcActive() {
      return this.$configData?.auth?.oidc?.active;
    },
  },
  methods: {
    ...mapActions('storeAuth', ['loginSaml', 'loginOidc']),
    onLogin() {
      if (this.oidcActive) {
        this.loginOidc();
      } else if (this.samlActive) {
        this.loginSaml();
      } else {
        this.$router.push('signin').catch(() => {
          /** */
        });
      }
    },
    onSignup() {
      this.$router.push('signup');
    },
  },
});
</script>
<style scoped lang="scss">
@import '../../sass/portal.scss';

.welcome-box {
  width: 500px;
  margin: 30px auto;
  padding: 20px;
  border-radius: 10px;
}
</style>
